// Complete ISO 3166-1 alpha-2 country list (~250 countries)
// Priority destinations first (México, US, Canada, then popular markets),
// then alphabetical by English name for the rest.
var PRIORITY = [
  { code: 'MX', name: 'México 🇲🇽' },
  { code: 'US', name: 'United States 🇺🇸' },
  { code: 'CA', name: 'Canada 🇨🇦' },
  { code: 'JP', name: 'Japan 🇯🇵' },
  { code: 'GB', name: 'United Kingdom 🇬🇧' },
  { code: 'FR', name: 'France 🇫🇷' },
  { code: 'DE', name: 'Germany 🇩🇪' },
  { code: 'IT', name: 'Italy 🇮🇹' },
  { code: 'ES', name: 'Spain 🇪🇸' },
  { code: 'AU', name: 'Australia 🇦🇺' },
];

// Rest of world (alphabetical)
var REST = [
  ['AF','Afghanistan 🇦🇫'],['AL','Albania 🇦🇱'],['DZ','Algeria 🇩🇿'],['AD','Andorra 🇦🇩'],
  ['AO','Angola 🇦🇴'],['AG','Antigua and Barbuda 🇦🇬'],['AR','Argentina 🇦🇷'],['AM','Armenia 🇦🇲'],
  ['AW','Aruba 🇦🇼'],['AT','Austria 🇦🇹'],['AZ','Azerbaijan 🇦🇿'],['BS','Bahamas 🇧🇸'],
  ['BH','Bahrain 🇧🇭'],['BD','Bangladesh 🇧🇩'],['BB','Barbados 🇧🇧'],['BY','Belarus 🇧🇾'],
  ['BE','Belgium 🇧🇪'],['BZ','Belize 🇧🇿'],['BJ','Benin 🇧🇯'],['BM','Bermuda 🇧🇲'],
  ['BT','Bhutan 🇧🇹'],['BO','Bolivia 🇧🇴'],['BA','Bosnia and Herzegovina 🇧🇦'],['BW','Botswana 🇧🇼'],
  ['BR','Brazil 🇧🇷'],['BN','Brunei 🇧🇳'],['BG','Bulgaria 🇧🇬'],['BF','Burkina Faso 🇧🇫'],
  ['BI','Burundi 🇧🇮'],['KH','Cambodia 🇰🇭'],['CM','Cameroon 🇨🇲'],['CV','Cape Verde 🇨🇻'],
  ['KY','Cayman Islands 🇰🇾'],['CF','Central African Republic 🇨🇫'],['TD','Chad 🇹🇩'],['CL','Chile 🇨🇱'],
  ['CN','China 🇨🇳'],['CO','Colombia 🇨🇴'],['KM','Comoros 🇰🇲'],['CG','Congo 🇨🇬'],
  ['CD','Congo (DRC) 🇨🇩'],['CR','Costa Rica 🇨🇷'],['CI','Côte d\'Ivoire 🇨🇮'],['HR','Croatia 🇭🇷'],
  ['CU','Cuba 🇨🇺'],['CY','Cyprus 🇨🇾'],['CZ','Czechia 🇨🇿'],['DK','Denmark 🇩🇰'],
  ['DJ','Djibouti 🇩🇯'],['DM','Dominica 🇩🇲'],['DO','Dominican Republic 🇩🇴'],['EC','Ecuador 🇪🇨'],
  ['EG','Egypt 🇪🇬'],['SV','El Salvador 🇸🇻'],['GQ','Equatorial Guinea 🇬🇶'],['ER','Eritrea 🇪🇷'],
  ['EE','Estonia 🇪🇪'],['SZ','Eswatini 🇸🇿'],['ET','Ethiopia 🇪🇹'],['FJ','Fiji 🇫🇯'],
  ['FI','Finland 🇫🇮'],['GA','Gabon 🇬🇦'],['GM','Gambia 🇬🇲'],['GE','Georgia 🇬🇪'],
  ['GH','Ghana 🇬🇭'],['GR','Greece 🇬🇷'],['GL','Greenland 🇬🇱'],['GD','Grenada 🇬🇩'],
  ['GP','Guadeloupe 🇬🇵'],['GU','Guam 🇬🇺'],['GT','Guatemala 🇬🇹'],['GN','Guinea 🇬🇳'],
  ['GW','Guinea-Bissau 🇬🇼'],['GY','Guyana 🇬🇾'],['HT','Haiti 🇭🇹'],['HN','Honduras 🇭🇳'],
  ['HK','Hong Kong 🇭🇰'],['HU','Hungary 🇭🇺'],['IS','Iceland 🇮🇸'],['IN','India 🇮🇳'],
  ['ID','Indonesia 🇮🇩'],['IR','Iran 🇮🇷'],['IQ','Iraq 🇮🇶'],['IE','Ireland 🇮🇪'],
  ['IL','Israel 🇮🇱'],['JM','Jamaica 🇯🇲'],['JO','Jordan 🇯🇴'],['KZ','Kazakhstan 🇰🇿'],
  ['KE','Kenya 🇰🇪'],['KW','Kuwait 🇰🇼'],['KG','Kyrgyzstan 🇰🇬'],['LA','Laos 🇱🇦'],
  ['LV','Latvia 🇱🇻'],['LB','Lebanon 🇱🇧'],['LS','Lesotho 🇱🇸'],['LR','Liberia 🇱🇷'],
  ['LY','Libya 🇱🇾'],['LI','Liechtenstein 🇱🇮'],['LT','Lithuania 🇱🇹'],['LU','Luxembourg 🇱🇺'],
  ['MO','Macao 🇲🇴'],['MG','Madagascar 🇲🇬'],['MW','Malawi 🇲🇼'],['MY','Malaysia 🇲🇾'],
  ['MV','Maldives 🇲🇻'],['ML','Mali 🇲🇱'],['MT','Malta 🇲🇹'],['MH','Marshall Islands 🇲🇭'],
  ['MQ','Martinique 🇲🇶'],['MR','Mauritania 🇲🇷'],['MU','Mauritius 🇲🇺'],['FM','Micronesia 🇫🇲'],
  ['MD','Moldova 🇲🇩'],['MC','Monaco 🇲🇨'],['MN','Mongolia 🇲🇳'],['ME','Montenegro 🇲🇪'],
  ['MA','Morocco 🇲🇦'],['MZ','Mozambique 🇲🇿'],['MM','Myanmar 🇲🇲'],['NA','Namibia 🇳🇦'],
  ['NR','Nauru 🇳🇷'],['NP','Nepal 🇳🇵'],['NL','Netherlands 🇳🇱'],['NC','New Caledonia 🇳🇨'],
  ['NZ','New Zealand 🇳🇿'],['NI','Nicaragua 🇳🇮'],['NE','Niger 🇳🇪'],['NG','Nigeria 🇳🇬'],
  ['MK','North Macedonia 🇲🇰'],['NO','Norway 🇳🇴'],['OM','Oman 🇴🇲'],['PK','Pakistan 🇵🇰'],
  ['PW','Palau 🇵🇼'],['PA','Panama 🇵🇦'],['PG','Papua New Guinea 🇵🇬'],['PY','Paraguay 🇵🇾'],
  ['PE','Peru 🇵🇪'],['PH','Philippines 🇵🇭'],['PL','Poland 🇵🇱'],['PT','Portugal 🇵🇹'],
  ['PR','Puerto Rico 🇵🇷'],['QA','Qatar 🇶🇦'],['RE','Réunion 🇷🇪'],['RO','Romania 🇷🇴'],
  ['RU','Russia 🇷🇺'],['RW','Rwanda 🇷🇼'],['KN','Saint Kitts and Nevis 🇰🇳'],['LC','Saint Lucia 🇱🇨'],
  ['VC','Saint Vincent 🇻🇨'],['WS','Samoa 🇼🇸'],['SM','San Marino 🇸🇲'],['SA','Saudi Arabia 🇸🇦'],
  ['SN','Senegal 🇸🇳'],['RS','Serbia 🇷🇸'],['SC','Seychelles 🇸🇨'],['SL','Sierra Leone 🇸🇱'],
  ['SG','Singapore 🇸🇬'],['SK','Slovakia 🇸🇰'],['SI','Slovenia 🇸🇮'],['SB','Solomon Islands 🇸🇧'],
  ['SO','Somalia 🇸🇴'],['ZA','South Africa 🇿🇦'],['KR','South Korea 🇰🇷'],['SS','South Sudan 🇸🇸'],
  ['LK','Sri Lanka 🇱🇰'],['SD','Sudan 🇸🇩'],['SR','Suriname 🇸🇷'],['SE','Sweden 🇸🇪'],
  ['CH','Switzerland 🇨🇭'],['SY','Syria 🇸🇾'],['TW','Taiwan 🇹🇼'],['TJ','Tajikistan 🇹🇯'],
  ['TZ','Tanzania 🇹🇿'],['TH','Thailand 🇹🇭'],['TL','Timor-Leste 🇹🇱'],['TG','Togo 🇹🇬'],
  ['TO','Tonga 🇹🇴'],['TT','Trinidad and Tobago 🇹🇹'],['TN','Tunisia 🇹🇳'],['TR','Türkiye 🇹🇷'],
  ['TM','Turkmenistan 🇹🇲'],['TC','Turks and Caicos 🇹🇨'],['TV','Tuvalu 🇹🇻'],['UG','Uganda 🇺🇬'],
  ['UA','Ukraine 🇺🇦'],['AE','United Arab Emirates 🇦🇪'],['UY','Uruguay 🇺🇾'],['UZ','Uzbekistan 🇺🇿'],
  ['VU','Vanuatu 🇻🇺'],['VA','Vatican City 🇻🇦'],['VE','Venezuela 🇻🇪'],['VN','Vietnam 🇻🇳'],
  ['VG','Virgin Islands (British) 🇻🇬'],['VI','Virgin Islands (US) 🇻🇮'],['YE','Yemen 🇾🇪'],
  ['ZM','Zambia 🇿🇲'],['ZW','Zimbabwe 🇿🇼']
].map(function(p) { return { code: p[0], name: p[1] }; });

var SHIPPING_COUNTRIES = PRIORITY.concat(REST);

export default SHIPPING_COUNTRIES;
